import ArrowCircleClockwiseIcon from '@motional/inguitiv/svg/icon/arrow-circle-clockwise.svg?react';

function Icon() {
  return <ArrowCircleClockwiseIcon />;
}

export default Icon;
